import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {
    if(!$('#insta-images-holder').length) {
        return;
    }

    const options = {
        rootMargin: '100px 0px',
        threshold: 0.0,
    };

    var instaLazyObserver = new IntersectionObserver((entries, observer) => {
        for (var i = 0; i < entries.length; i++) { 
            const entry = entries[i];
            if (entry.intersectionRatio > 0.0) {
                const image = entry.target;
                image.style.backgroundImage = 'url('+ image.getAttribute('data-insta-image') +')';
                image.removeAttribute('data-insta-image');
                observer.unobserve(entry.target);
            }
        }
    }, options);

    var token = $('#insta-images-holder').data('tk'),
    userID = $('#insta-images-holder').data('us'),
    numPhotos = 5;
 
    $.ajax({
        url: 'https://api.instagram.com/v1/users/' + userID + '/media/recent',
        dataType: 'jsonp',
        type: 'GET',
        data: {access_token: token, count: numPhotos},
        success: function(data){
            for( var x in data.data ){
                $('#insta-images-holder').append('<li><a href="'+ data.data[x].link +'" target="_blank"><div class="insta-img" data-insta-image="'+ data.data[x].images.standard_resolution.url +'"></div></a></li>');
            }

            $('#insta-images-holder').each(function() {
                tns({
                    container: $(this)[0],
                    autoplay: false,
                    autoplayButtonOutput: false,
                    speed: 2000,
                    touch: true,
                    controls: true,
                    controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
                    nav: false,
                    items: 1,
                    loop: false,
                    preventScrollOnTouch: 'auto',
                    responsive: {
                        1: {
                          items: 1,
                        },
                        768: {
                            items: 3,
                        },
                        981: {
                          items: 4,
                        },
                        1200: {
                            items: 5,
                        },
                      },
                });
            });

            $('[data-insta-image]').each(function() {
                if(!$(this).data('insta-image')) {
                    return;
                }
    
                instaLazyObserver.observe($(this)[0])
            })

        },
        error: function(data){
            console.log(data);
        },
    });
});



// WEBPACK FOOTER //
// ./scripts/components/instagram-feed.js